import { ReactNode, createContext, useContext, useReducer } from "react";
import merge from "lodash/merge";

const initialState = {
  productList: [],
};

const edbContextReducer = (state, action) => {
  switch (action.type) {
    case "addOrders":
      return {
        ...state,
        ...action.payload,
      };

    default: {
      throw Error(`Unknown action: ${action.type}`);
    }
  }
};

export const EdbContext = createContext(null);
export const EdbContextDispatch = createContext(null);

export const useEdbContext = () => useContext(EdbContext);
export const useEdbDispatch = () => useContext(EdbContextDispatch);

export const EdbProvider = ({
  children,
  externalState = initialState,
}: {
  children: ReactNode;
  externalState?: Partial<typeof initialState>;
}) => {
  const [edbstate, dispatch] = useReducer(
    edbContextReducer,
    merge(initialState, externalState)
  );

  return (
    <EdbContext.Provider value={edbstate}>
      <EdbContextDispatch.Provider value={dispatch}>
        {children}
      </EdbContextDispatch.Provider>
    </EdbContext.Provider>
  );
};
